import * as actions from "./dam.actions";
import Store, { RootState } from "../../../redux/store";
import { createSelector } from "reselect";
import { DamState } from "../types/dam-state/dam-state.interface";

export const getDamState = (state: RootState) => state.damState;

export const getSignature = createSelector(getDamState, (state: DamState) => state.signature);

export const getSignatureFetchedAt = createSelector(
  getDamState,
  (state: DamState) => state.signatureFetchedAt
);

export const isLoading = createSelector(getDamState, (state: DamState) => state.isLoading);

export function init() {
  Store.dispatch(actions.init());
}
